import { indexOf } from 'lodash';
import React, { useState } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import styled from '@emotion/styled';

import { CategorySearch, SearchType } from '../../types';

interface Props {
  categorySearches: CategorySearch[];
  searchText: string;
  onSelectSearch: (searchType: SearchType) => void;
  selectedSearches: number[];
}
const SearchTypeChooser = (props: Props) => {
  const [activeIndexes, setActiveIndexes] = useState([]);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    let indexes = [...activeIndexes];
    const indexOfClicked = indexes.findIndex(i => i === index);
    if (indexOfClicked > -1) {
      indexes.splice(indexOfClicked, 1);
    } else {
      indexes.push(index);
    }
    setActiveIndexes(indexes);
  };

  return (
    <Accordion exclusive={false}>
      {props.categorySearches.map((cs, i) => {
        return (
          <Root>
            <Accordion.Title
              active={activeIndexes.includes(cs.id) || Boolean(props.searchText)}
              index={cs.id}
              onClick={handleClick}
            >
              <Icon name="dropdown" />
              {cs.category}
            </Accordion.Title>
            <Accordion.Content active={activeIndexes.includes(cs.id) || Boolean(props.searchText)}>
              {cs.searchTypes
                .filter(st => !props.selectedSearches.includes(st.id))
                .filter(s => s.type?.toLowerCase().includes(props.searchText.toLowerCase()))
                .map(st => {
                  return (
                    <>
                      <div
                        onClick={() => {
                          props.onSelectSearch(st);
                        }}
                      >
                        {st.type}
                      </div>
                    </>
                  );
                })}
            </Accordion.Content>
          </Root>
        );
      })}
    </Accordion>
  );
};

export default SearchTypeChooser;

const Root = styled.div`
  .content.active {
    margin-left: 24px;
    div {
      font-weight: 400;
      font-size: 14px;
      min-height: 32px;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 4px 8px;
      border-radius: 2px;
      transition: all 0.1s;
      :hover {
        background-color: #f1f1f1;
        color: #ff5252;
      }
    }
  }
`;
